/**
 * @fileoverview AR-805 — one attachment mirrored from a delivery made in
 * Google Classroom (PRD §1 inbound: "student work submitted in Classroom is
 * imported into ArcMosaico as a deliverable submission, with attachments").
 *
 * Read-only by design: the front NEVER writes attachments. The import is done
 * by the backend, atomically per delivery — this component only renders what
 * is already there.
 *
 * Anatomy copied from the prototype (StudentDeliverableSubmitDrawer.tsx
 * L1091-1127, branch `file.type === 'classroom'`): Classroom logo + truncated
 * name, same row shape as the platform's own file rows.
 *
 * `memo` because it renders inside a list: a parent re-render (drawer state,
 * a link being removed) must not repaint every attachment row.
 */

import { memo } from 'react'
import { Anchor, Box, Group, Text } from '@mantine/core'

import { GoogleClassroomLogo } from 'components/GoogleClassroomLogo'

export interface ClassroomAttachment {
  id: string
  name: string
  url: string
  iconUrl: string | null
}

interface ClassroomAttachmentLinkProps {
  readonly file: ClassroomAttachment
}

export const ClassroomAttachmentLink = memo(function ClassroomAttachmentLink({
  file,
}: ClassroomAttachmentLinkProps) {
  return (
    <Anchor href={file.url} target='_blank' rel='noopener noreferrer' size='sm'>
      <Group spacing={6} noWrap>
        <Box sx={{ flexShrink: 0, display: 'flex' }}>
          <GoogleClassroomLogo size={16} />
        </Box>
        <Text size='sm' lineClamp={1}>
          {file.name}
        </Text>
      </Group>
    </Anchor>
  )
})
